// Temperature → colour ramp, shared by the hourly graph line and the 7-day bars so
// both encode temperature the same way: the 7-day temp-bar palette (blue → yellow →
// orange) + red for the hottest, mapped to ABSOLUTE °F (not a per-element range), so
// a cool hour/day reads blue and a hot one reads orange/red — comparable everywhere.

export type RGB = [number, number, number]

const TEMP_STOPS: [number, RGB][] = [
  [20, [37, 99, 235]], // #2563eb deep blue (very cold)
  [40, [59, 130, 246]], // #3b82f6 blue (status-info)
  [62, [255, 210, 26]], // #ffd21a yellow (status-watch)
  [82, [255, 127, 0]], // #ff7f00 orange (status-warn)
  [98, [255, 49, 49]], // #ff3131 red (status-severe)
]
const lerp = (a: number, b: number, f: number) => a + (b - a) * f

/** CSS `rgb(...)` for a temperature in °F along the absolute ramp. */
export function tempColor(t: number): string {
  const s = TEMP_STOPS
  if (t <= s[0][0]) return `rgb(${s[0][1].join(',')})`
  if (t >= s[s.length - 1][0]) return `rgb(${s[s.length - 1][1].join(',')})`
  for (let i = 0; i < s.length - 1; i++) {
    const [t0, c0] = s[i]
    const [t1, c1] = s[i + 1]
    if (t >= t0 && t <= t1) {
      const f = (t - t0) / (t1 - t0)
      return `rgb(${Math.round(lerp(c0[0], c1[0], f))},${Math.round(lerp(c0[1], c1[1], f))},${Math.round(lerp(c0[2], c1[2], f))})`
    }
  }
  return `rgb(${s[s.length - 1][1].join(',')})`
}
